// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","primary":"Button_primary__xATCt","secondary":"Button_secondary__jf-7T","tertiary":"Button_tertiary__cZMdb"};